import $ from '../jquery';
import Device from '../device';
import SpacesApp from '../android/api';
import {addEvent} from '../core/events';

// Настройки для свайпа
const SIDEBAR_CONTENT_OFFSET = Device.type == 'touch' ? '-240%' : '-120%';
const SIDEBAR_NO_SWIPE = !!navigator.userAgent.match(/(UCBrowser|UCWEB)/i) || Device.type != 'touch' || Device.android_app;

const SIDEBAR_GESTURE_MIN_X = 50;
const SIDEBAR_GESTURE_MAX_Y = 60;

let locked = false, last_scroll = 0;

init();

function init() {
	let click_handler = (e) => {
		toggle();
		return false;
	};
	
	let resize_handler = (e) => {
		if ($('body').hasClass('root--is-sidebar-open') && $(window).innerWidth() >= 900)
			toggle(false);
	};
	
	$('#header_elements').on('click', '#home_link', click_handler);
	$('#js-root-overlay').on('click', click_handler);
	
	addEvent(window, 'resize', resize_handler, {passive: true});
	addEvent(window, 'orientationchange', resize_handler, {passive: true});
	
	initSwipe();
}

function initSwipe() {
	let body = document.body;
	if (!body.addEventListener || SIDEBAR_NO_SWIPE)
		return;
	
	let can_passive = Device.can('passiveEvents');
	
	let start_x = 0, start_y = 0, gesture = false;
	
	addEvent(body, 'touchstart', (e) => {
		if (locked)
			return;
		
		gesture = !e.touches || e.touches.length == 1;
		start_x = e.touches ? e.touches[0].clientX : e.clientX;
		start_y = e.touches ? e.touches[0].clientY : e.clientY;
	}, {passive: true});
	
	addEvent(body, 'touchmove', (e) => {
		if (!gesture)
			return;
		
		let x = e.touches ? e.touches[0].clientX : e.clientX,
			y = e.touches ? e.touches[0].clientY : e.clientY,
			
			dX = Math.abs(x - start_x),
			dY = Math.abs(y - start_y);
		
		if (dY > SIDEBAR_GESTURE_MAX_Y) {
			gesture = false;
		} else {
			if (dX * 0.66 >= dY) {
				if (dX >= SIDEBAR_GESTURE_MIN_X) {
					let is_open = start_x <= x;
					gesture = false;

					if (!locked) {
						setTimeout(() => toggle(is_open), 0);
					}
				}
			} else {
				gesture = false;
			}
		}
	}, {passive: true});
}

function toggle(state) {
	let body = $("body");
	let sidebar = $('#sidebar_wrap');
	let sidebar_bg = $('#js-sidebar-bg');
	
	if (state == null)
		state = !body.hasClass('root--is-sidebar-open');
	
	if (Device.android_app) {
		if (state) {
			last_scroll = $(window).scrollTop();
			$('html, body').scrollTop(0);
			$('#siteContent').css({marginTop: -last_scroll});
		} else {
			$('#siteContent').css({marginTop: 0});
			$('html, body').scrollTop(last_scroll);
		}
	}
	
	if (!sidebar.data('noDark')) {
		sidebar_bg.toggleClass('sidebar--dark', sidebar.data('dark') == 1 || state);
		sidebar.toggleClass('sidebar--dark', sidebar.data('dark') == 1 || state);
	}
	
	body.toggleClass("root--is-sidebar-open", state);
	$('#home_link').toggleClass("horiz-menu__link_no_hover", state);
}

function lock(flag) {
	locked = flag;
	
	if (Device.android_app)
		SpacesApp.exec('sidebar', {enable: !flag});
}

export {toggle, lock};
